'use client'

export { CurrencyInput, type CurrencyInputProps } from './currency-input'
